
// assets imports
import jsonClassificacaoForm from "json/ClassificacaoTaxas.json"
import { CheckboxInput, Radio } from "components/Inputs"

export function getFeatureFormFields(tipoImovel)
{
    const { Uniresidencial, ComercioMisto, GLP } = jsonClassificacaoForm
    const tiposImovel =
    {
        "Uniresidencial": Uniresidencial,
        "Não residencial / misto": ComercioMisto,
        "Condomínio de lotes comercial": ComercioMisto,
        "GLP": GLP
    }

    if (!(tipoImovel in tiposImovel)) { return null }
    
    
    return tiposImovel[tipoImovel]

}

export function ClassificationEdifForm({ TipoImovel })
{

    let fields = getFeatureFormFields(TipoImovel)
    
    if (fields === null) { return }

    const classificationEdifForm =
    <div id="classificaForm" className="form-floating mt-3">
        {fields.map( (field, index) =>
        field.TipoInput === "Checkbox" ?
        <CheckboxInput Name={field.Nome} Label={field.Titulo} Req={false} key={field.Nome + index}/> :
        <Radio key={field.Nome + field.Caracteristicas[index]} Name={field.Nome} Label={field.Titulo} Options={field.Caracteristicas} Req={true} />
        )}
    </div>

    return (
        <div className="m-auto my-2 p-2 border border-dark rounded-2" name="Classification form" style={{maxWidth:"400px"}}>
            <p className="fw-bold text-center">Classificação da edificação</p>
            {classificationEdifForm}
        </div>
    )

}